import {Backdrop, Box, Grid2, CircularProgress, Stack, Typography} from '@mui/material'
import { useEffect, useState, useContext } from 'react';
import { Context } from "../App";
import Dashboard from './Dashboard';
import AppLayout from '../components/layout/AppLayout';

function Statistiques() {
  const { setIsConnected } = useContext(Context)
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))

  useEffect(()=> {
    if (!user || user.role === 'user') {
      sessionStorage.clear();
      setIsConnected(false);
    }
  }, [user])


  return (
    <Dashboard/>
  );
}

export default Statistiques;
